<template>
    <div
        class="no-rows-overlay display-flex align-items-center justify-center align-content-center flex-wrap"
    >
        <h6 class="w-100 mb-md">{{ params.message }}</h6>
        <AonButton
            v-if="params.showResetFilterButton"
            label="Clear Filters"
            type="prominent"
            @clicked="resetFiltersAction()"
        />
    </div>
</template>

<script setup>
import { onMounted } from 'vue'

const emit = defineEmits(['setup-arena'])
const props = defineProps({
    params: Object,
})

onMounted(() => {})

const resetFiltersAction = () => {
    props.params.resetFilters()
}
</script>

<style lang="scss">
@use '@moatmetrics/armory/src/sass/token-utils' as tokens;

.no-rows-overlay {
    width: 100%;
    height: 90%;
    padding-top: 10%;
    background: var(--color-background-default);
}
</style>
